// Function to get string name from enum and number
// eslint-disable-next-line import/prefer-default-export
export const getNameFromEnumNumber = (enumObj: any, num: number) => {
  return Object.keys(enumObj).find((key) => enumObj[key] === num);
};
